import Player from '@vimeo/player/dist/player.es';
import { WebinarWatcher } from '../../../../../vet-webinar-watcher/Resources/Private/JavaScript/webinar-watcher';

/**
 * Handles the FancyBox lightbox + Vimeo player + WebinarWatcher integration for any webinar action
 * button inside a `[data-webinar-actions]` container.
 *
 * Rating- and quiz-state side effects (e.g. enabling the rating UI in the agenda) are emitted as
 * `vet-agenda-actions:video-*` DOM custom events so agenda-specific code can hook in without
 * the popup logic having to know about agenda DOM details.
 *
 * Quiz-button enabling happens here because the quiz button is part of the same partial: it sits
 * inside the matching `[data-webinar-actions]` container, so a scoped lookup works in both the
 * agenda list view and the GX search overlay.
 */
export class VideoPopup {
    constructor() {
        const fancyboxSelector = '[data-webinar-actions] [data-fancybox]';
        const webinarVideoSelector = '[data-webinar-actions] [data-webinar-video]';

        jQuery(fancyboxSelector).fancybox({
            afterShow: () => {
                if (typeof _paq !== 'undefined') {
                    _paq.push(['MediaAnalytics::scanForMedia']);
                }
            },
        });

        jQuery(webinarVideoSelector).on('click', (event) => {
            event.preventDefault();
            this.handleVideoClick(event.currentTarget);
        });
    }

    handleVideoClick(target) {
        const $target = jQuery(target);
        const webinarUid = parseInt($target.data('webinar'), 10);
        const initialWatchedTime = parseInt($target.data('webinar-watched-time'), 10) || 0;
        const webinarEnded = $target.data('webinar-ended') === '1';
        const webinarType = 'agenda';

        this.dispatchVideoEvent(target, 'video-opened', { webinarUid });

        if (webinarEnded) {
            return;
        }

        let acceptablePercentage = parseFloat($target.data('acceptable-percentage')) / 100;
        if (isNaN(acceptablePercentage) || acceptablePercentage <= 0) {
            acceptablePercentage = 0.8;
        }

        const fancyboxInstance = jQuery.fancybox.getInstance();
        if (!fancyboxInstance || !fancyboxInstance.$refs || !fancyboxInstance.$refs.inner[0]) {
            return;
        }

        const iframe = fancyboxInstance.$refs.inner[0].querySelector('iframe');
        if (!iframe) {
            return;
        }

        new WebinarWatcher(iframe, webinarUid, initialWatchedTime, webinarEnded, webinarType);

        const player = new Player(iframe);
        let amountWatched = 0.0;
        let previousTime = 0.0;
        let thresholdDispatched = false;

        player.on('timeupdate', (data) => {
            const diff = Math.abs(previousTime - data.seconds);
            if (diff < 0.5) {
                amountWatched += diff;
            }
            previousTime = data.seconds;

            if (data.percent >= acceptablePercentage) {
                $target.data('webinar-watched-time', amountWatched);

                if (!thresholdDispatched) {
                    thresholdDispatched = true;
                    this.enableQuiz(webinarUid);
                    this.dispatchVideoEvent(target, 'video-threshold-reached', { webinarUid });
                }
            }
        });

        player.on('ended', () => {
            $target.data('webinar-ended', '1');
            this.dispatchVideoEvent(target, 'video-ended', { webinarUid });
        });
    }

    enableQuiz(webinarUid) {
        const container = document.querySelector(
            '[data-webinar-actions][data-webinar="' + webinarUid + '"]',
        );
        if (!container) {
            return;
        }
        const quizLink = container.querySelector('.c-agenda__quiz-btn');
        if (quizLink) {
            quizLink.classList.add('c-agenda__quiz-btn--show');
        }
    }

    dispatchVideoEvent(target, name, detail) {
        const event = new CustomEvent('vet-agenda-actions:' + name, {
            bubbles: true,
            cancelable: false,
            detail,
        });
        target.dispatchEvent(event);
    }
}
